import { AlpineComponent } from '@nxtlvlsoftware/alpine-typescript';
import Cookies from 'js-cookie'

export class AnnouncementComponent extends AlpineComponent {

    private announcementId: string;

    public show: Boolean = false;
    constructor(announcementId:string) {
        super();
        this.announcementId = announcementId;
    }

    init(): void {
        this.show = Cookies.get(`hide-announcement-${this.announcementId}`) == undefined || Cookies.get(`hide-announcement-${this.announcementId}`) == "false";
    }
    hide(): void {
        this.show = false;
        Cookies.set(`hide-announcement-${this.announcementId}`, "true");
    }

    protected announcementBackground = this.binding({
        ["x-transition:enter"]: "ease-out duration-500",
        ["x-transition:enter-start"]: "opacity-0",
        ["x-transition:enter-end"]: "opacity-100",
        ["x-transition:leave"]: "ease-in duration-500",
        ["x-transition:leave-start"]: "opacity-100",
        ["x-transition:leave-end"]: "opacity-0",
        ["x-show"]() {
            return this.show
        },
    });

    protected announcementDismiss = this.binding({
        ["x-on:click"]() {
            this.hide();
        },
    });
}